export default __webpack_public_path__ + "static/media/office2-afterA-768w.611a4f36.png";